__turbopack_context__.v({
  "author": "Z91UjG_author",
  "author-container": "Z91UjG_author-container",
  "avatar": "Z91UjG_avatar",
  "caption": "Z91UjG_caption",
});
